import React from 'react';
import PropTypes from 'prop-types';
import { graphql } from 'gatsby';

import PageHero from './PageHero';
import Block from './Block';
import Carousel from './Carousel';

const PageHeroCarousel = ({ content }) => (
  <Block position="relative" id={content.primary.internal_link_id}>
    <Carousel
      autoplay={Boolean(content.primary.autoplay)}
      slideInterval={content.primary.slide_interval || 10}
      dotsInsideCarousel
    >
      {content.items.map((item, i) => (
        <Block
          key={`hero-item-${item.headline.text}-${i}`}
          style={{ minWidth: '100%' }}
        >
          <PageHero content={item} />
        </Block>
      ))}
    </Carousel>
  </Block>
);

PageHeroCarousel.propTypes = {
  content: PropTypes.shape({
    primary: PropTypes.shape({
      internal_link_id: PropTypes.string,
      autoplay: PropTypes.bool.isRequired,
      slide_interval: PropTypes.number,
    }),
    items: PropTypes.arrayOf(
      PropTypes.shape({
        headline: PropTypes.shape({ text: PropTypes.string }),
        subtitle: PropTypes.shape({ text: PropTypes.string }),
        coral_subtitle: PropTypes.shape({ text: PropTypes.string }),
        video: PropTypes.shape({ url: PropTypes.string }),
        image: PropTypes.shape({
          alt: PropTypes.string,
          localFile: PropTypes.shape({
            childImageSharp: PropTypes.shape({ fluid: PropTypes.shape({}) }),
          }),
        }),
        call_to_action_color: PropTypes.string,
        call_to_action_text: PropTypes.shape({ text: PropTypes.string }),
        call_to_action_link: PropTypes.shape({
          url: PropTypes.string,
          link_type: PropTypes.string,
          lang: PropTypes.string,
          target: PropTypes.string,
        }),
        no_overlay: PropTypes.bool,
      }),
    ),
  }).isRequired,
};

export default PageHeroCarousel;

export const query = graphql`
  fragment PageHeroCarouselFragment on PrismicPageBodyHeroCarousel {
    id
    slice_type
    primary {
      internal_link_id
      autoplay
      slide_interval
    }
    items {
      headline {
        text
      }
      subtitle {
        text
      }
      coral_subtitle {
        text
      }
      video {
        url
      }
      call_to_action_color
      call_to_action_text {
        text
      }
      call_to_action_link {
        link_type
        url
        lang
        target
      }
      no_overlay
      image {
        alt
        localFile {
          childImageSharp {
            fluid(maxWidth: 2500, maxHeight: 1200) {
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    }
  }
`;
